import React from 'react';
import { Progress } from 'antd';
import notification from 'utils/notificationBridge';
import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';

const PHASE_LABELS = {
  [PUBLISH_CONTENT_TYPES.BANNER]: {
    queued: 'Publishing banner…',
    'uploading-web-image': 'Uploading web image…',
    'uploading-mobile-image': 'Uploading mobile image…',
    creating: 'Saving banner…',
    updating: 'Updating banner…',
  },
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: {
    queued: 'Publishing template…',
    'uploading-fcm-image': 'Uploading FCM image…',
    'uploading-whatsapp-image': 'Uploading WhatsApp image…',
    creating: 'Saving template…',
    updating: 'Updating template…',
  },
};

const DEFAULT_TITLES = {
  [PUBLISH_CONTENT_TYPES.BANNER]: 'Banner',
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: 'Template',
};

const SUCCESS_MESSAGES = {
  [PUBLISH_CONTENT_TYPES.BANNER]: 'Banner added successfully.',
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: 'Template added successfully.',
};

const SUCCESS_MESSAGES_EDIT = {
  [PUBLISH_CONTENT_TYPES.BANNER]: 'Banner updated successfully.',
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: 'Template updated successfully.',
};

const FAILED_MESSAGES = {
  [PUBLISH_CONTENT_TYPES.BANNER]: 'Failed to publish banner.',
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: 'Failed to publish template.',
};

const FAILED_MESSAGES_EDIT = {
  [PUBLISH_CONTENT_TYPES.BANNER]: 'Failed to update banner.',
  [PUBLISH_CONTENT_TYPES.TEMPLATE]: 'Failed to update template.',
};

const STMARYS_MODULE_LABELS = {
  [PUBLISH_CONTENT_TYPES.GALLERY]: 'Gallery',
  [PUBLISH_CONTENT_TYPES.OFFICIAL_CONTACT]: 'Official contact',
  [PUBLISH_CONTENT_TYPES.ADMINISTRATION]: 'Administration',
  [PUBLISH_CONTENT_TYPES.PARISH_PRIEST]: 'Parish Priest',
  [PUBLISH_CONTENT_TYPES.LEADERSHIP_HISTORY]: 'Leadership history',
  [PUBLISH_CONTENT_TYPES.HOUSE]: 'House',
  [PUBLISH_CONTENT_TYPES.HISTORY]: 'History',
  [PUBLISH_CONTENT_TYPES.HIERARCHY]: 'Hierarchy',
  [PUBLISH_CONTENT_TYPES.CHURCH]: 'Church',
  [PUBLISH_CONTENT_TYPES.ORGANIZATION]: 'Organization',
  [PUBLISH_CONTENT_TYPES.MEMBERS]: 'Member',
  [PUBLISH_CONTENT_TYPES.CHAPEL]: 'Chapel',
  [PUBLISH_CONTENT_TYPES.NEWS]: 'News',
  [PUBLISH_CONTENT_TYPES.FESTIVALS]: 'Festival',
  [PUBLISH_CONTENT_TYPES.ADVERTISEMENT]: 'Advertisement',
  [PUBLISH_CONTENT_TYPES.OCCASION]: 'Occasion',
  [PUBLISH_CONTENT_TYPES.LIVE_STREAMING]: 'Live streaming',
  [PUBLISH_CONTENT_TYPES.INCOME_PDF_LINK]: 'Income PDF link',
  [PUBLISH_CONTENT_TYPES.EVENTS]: 'Event',
  [PUBLISH_CONTENT_TYPES.QUOTES]: 'Quote',
  [PUBLISH_CONTENT_TYPES.POSITION]: 'Position',
};

Object.entries(STMARYS_MODULE_LABELS).forEach(([type, label]) => {
  DEFAULT_TITLES[type] = label;
  PHASE_LABELS[type] = {
    queued: `Publishing ${label.toLowerCase()}…`,
    'uploading-image': 'Uploading image…',
    creating: `Saving ${label.toLowerCase()}…`,
    updating: `Updating ${label.toLowerCase()}…`,
  };
  SUCCESS_MESSAGES[type] = `${label} added successfully.`;
  SUCCESS_MESSAGES_EDIT[type] = `${label} updated successfully.`;
  FAILED_MESSAGES[type] = `Failed to publish ${label.toLowerCase()}.`;
  FAILED_MESSAGES_EDIT[type] = `Failed to update ${label.toLowerCase()}.`;
});

const getPhaseLabel = (contentType, phase) =>
  PHASE_LABELS[contentType]?.[phase] ||
  PHASE_LABELS[contentType]?.queued ||
  'Publishing…';

export const getContentPublishNotificationKey = (jobId) =>
  `content-publish-${jobId}`;

export const openContentPublishNotification = ({
  jobId,
  title,
  contentType,
  phase,
  percent,
}) => {
  notification.open({
    key: getContentPublishNotificationKey(jobId),
    title: title || DEFAULT_TITLES[contentType] || 'Publishing',
    description: (
      <>
        <p style={{ margin: '0 0 8px' }}>{getPhaseLabel(contentType, phase)}</p>
        <Progress percent={percent} size="small" status="active" />
      </>
    ),
    duration: 0,
  });
};

export const closeContentPublishNotification = (jobId) => {
  notification.destroy(getContentPublishNotificationKey(jobId));
};

export const getPublishSuccessMessage = (contentType, mode) =>
  (mode === 'EDIT' ? SUCCESS_MESSAGES_EDIT : SUCCESS_MESSAGES)[contentType] ||
  (mode === 'EDIT' ? 'Updated successfully.' : 'Published successfully.');

export const getPublishFailedMessage = (contentType, mode) =>
  (mode === 'EDIT' ? FAILED_MESSAGES_EDIT : FAILED_MESSAGES)[contentType] ||
  (mode === 'EDIT' ? 'Update failed.' : 'Publish failed.');
